import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import minifyCssString from 'minify-css-string';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      minifyTheme: (string) => {
        const minify = minifyCssString(string);
        return minify.replace(/\.v-application/gm, '.v-component');
      },
    },
  },
});
